if (!customElements.get('product-bundle-form')) {
  customElements.define(
    'product-bundle-form',
    class ProductBundleForm extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this._handleClick = (e) => this.handleAddToCart(e);
        if (this.button) {
          this.button.addEventListener('click', this._handleClick);
        }
      }

      async handleAddToCart(e) {
        e.preventDefault();

        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          console.error('ProductBundleForm: no variant ID found');
          return;
        }

        const originalText = this.button.textContent;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const response = await fetch(routes.cart_add_url, config);
          const parsedResponse = await response.json();

          if (parsedResponse.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-bundle-form',
              productVariantId: variantId,
              errors: parsedResponse.errors || parsedResponse.description,
              message: parsedResponse.message,
            });
            this.button.textContent = 'Error — try again';
            setTimeout(() => {
              this.button.textContent = originalText;
              this.button.removeAttribute('aria-disabled');
            }, 3000);
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-bundle-form',
            productVariantId: variantId,
            cartData: parsedResponse,
          });

          this.cart.renderContents(parsedResponse);

          this.button.textContent = 'Added to cart!';
          setTimeout(() => {
            this.button.textContent = originalText;
          }, 2000);
        } catch (error) {
          console.error('ProductBundleForm add to cart error:', error);
          this.button.textContent = 'Error — try again';
          setTimeout(() => {
            this.button.textContent = originalText;
          }, 3000);
        } finally {
          this.button.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          this.button.removeAttribute('aria-disabled');
        }
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this._handleClick);
        }
      }
    }
  );
}
